import { createAsyncSelectorResults } from 'async-selector-kit'
import { onIsLoading } from '../../../../utils/onLoading'
import { actions as appActions } from '../../../App/reducer'
import { getApiConfig, getLocalServerURL } from '../../../../utils/getApiConfig'
import { Profile } from '../../types'
import { getProfileData, getProfileEmailData, onError } from './utils'
import { getPortalCustomerProfileId } from '../../../App/selectors'

export const [getProfile, getProfileLoading, getProfileError, getProfileForce] =
  createAsyncSelectorResults(
    {
      async: async (customerProfileId) => {
        const PATH = getLocalServerURL('/profiles/fetch')

        if (customerProfileId) {
          onIsLoading(true)
          const config = await getApiConfig({ body: { customerProfileId } })

          if (config != null) {
            const response = await fetch(PATH, config)
            if (!response.ok) {
              return onError('Failed to fetch profile', true) as Profile
            }

            const data = await response.json()
            if (data?.messages?.resultCode === 'Ok') {
              const profile = data.profile
              const paymentProfile = profile.paymentProfiles[0]
              const billTo = paymentProfile.billTo
              const creditCard = paymentProfile.payment.creditCard || {}
              const bankAccount = paymentProfile.payment.bankAccount || {}
              const shipToList = profile.shipToList[0]
              onIsLoading(false)
              const profileData = getProfileData({
                billTo,
                profile,
                data,
                shipToList,
                paymentProfile,
                creditCard,
                bankAccount,
              })
              window.store.dispatch(
                appActions.onSubscriptionIds(profileData.subscriptionIds)
              )
              return profileData
            } else {
              const error =
                data?.messages?.message?.[0]?.text || 'Unknown error'
              return onError(error, true) as Profile
            }
          }
        } else {
          onIsLoading(false)
          return getProfileEmailData()
        }
        onIsLoading(false)
        return {} as Profile
      },
      id: 'fetch-profile',
      defaultValue: {} as Profile,
    },
    [getPortalCustomerProfileId]
  )
